import styled from 'styled-components';
import { POPOVER_MAX_CONTENT_WIDTH } from './consts';

/**
 * Card body for popover content that isn't a single run of plain text — a stack
 * of rows, a header plus detail, an icon beside a label. Caps the card at
 * `POPOVER_MAX_WIDTH` and wraps long words rather than letting them stretch it.
 *
 * For content that _is_ just text, use `PlainTextPopover` instead — it carries a
 * tighter bound suited to a single paragraph.
 */
export const PopoverContent = styled.div`
  max-width: ${POPOVER_MAX_CONTENT_WIDTH}px;
  white-space: normal;
  overflow-wrap: break-word;
`;
